export function isRetryableAtomicRpcError(error: unknown): boolean {
  const value = error && typeof error === 'object'
    ? error as { code?: unknown; message?: unknown }
    : {};
  const code = typeof value.code === 'string' ? value.code : '';
  const message = typeof value.message === 'string'
    ? value.message
    : String(error);
  // Domain conflicts require a fresh user decision/request. Some stock RPCs
  // intentionally use SQLSTATE 40001 for optimistic-version conflicts, but
  // retrying the identical payload can never succeed and can flood Postgres.
  if (/_conflict(?:[:\s]|$)/i.test(message)) return false;
  return (
    ['55P03', '40001', '40P01'].includes(code)
    || /fetch|network|timeout|connection|offline|busy_retry|lock/i.test(message)
  );
}

/** A transport outage affects the whole drain; row-level failures do not. */
export function isSyncTransportUnavailableError(error: unknown): boolean {
  const value = error && typeof error === 'object'
    ? error as { name?: unknown; message?: unknown }
    : {};
  const name = typeof value.name === 'string' ? value.name : '';
  const message = typeof value.message === 'string'
    ? value.message
    : String(error);
  return name === 'AbortError'
    || /failed to fetch|load failed|network request failed|networkerror|connection (?:refused|reset)|\boffline\b/i.test(message);
}
